import React from "react";
import { StyledAppLogo } from "./index.styled";
import { useTypedSelector } from "@lib/redux";
import { APP_LOGO } from "@lib/constants/AppConst";
import { Link } from "react-router-dom";

type AppLogoProps = {
  isCollapsed?: boolean;
};

const AppLogo: React.FC<AppLogoProps> = ({ isCollapsed }) => {
  const { isDark } = useTypedSelector((state) => state.settings);
  const { height } = useTypedSelector((state) => state.screen.header);

  if (isCollapsed) {
    return (
      <Link to="/">
        <StyledAppLogo height={height}>
          {isDark ? (
            <img src={APP_LOGO.icon.dark} alt="logo" />
          ) : (
            <img src={APP_LOGO.icon.light} alt="logo" />
          )}
        </StyledAppLogo>
      </Link>
    );
  }

  return (
    <Link to="/">
      <StyledAppLogo height={height}>
        {isDark ? (
          <img src={APP_LOGO.full.dark} alt="logo" />
        ) : (
          <img src={APP_LOGO.full.light} alt="logo" />
        )}
      </StyledAppLogo>
    </Link>
  );
};

export default AppLogo;
